export default __webpack_public_path__ + "static/media/user-02.e06b215d.jpg";